import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

// Animation styles as an object for inline styling
const animationStyles = {
  dot0: {
    animation: 'bounce 1.4s infinite ease-in-out',
    animationDelay: '0s',
  },
  dot1: {
    animation: 'bounce 1.4s infinite ease-in-out',
    animationDelay: '0.16s',
  },
  dot2: {
    animation: 'bounce 1.4s infinite ease-in-out',
    animationDelay: '0.32s',
  },
};

// Create a CSS keyframes rule
const createKeyframes = () => {
  // Create the style element
  const styleEl = document.createElement('style');
  styleEl.type = 'text/css';

  // Define the keyframes
  const keyframes = `
    @keyframes bounce {
      0%, 80%, 100% { transform: translateY(0); }
      40% { transform: translateY(-5px); }
    }
  `;

  styleEl.appendChild(document.createTextNode(keyframes));
  document.head.appendChild(styleEl);
};

export const ChatIndicatorBubble = () => {
  // Add keyframes to document on first render
  React.useEffect(() => {
    createKeyframes();
  }, []);

  return (
    <Flex justify="flex-start" mb={4} w="100%">
      <Box
        bg="#F6F7F9"
        borderRadius="12px"
        p="10px"
        position="relative"
        minWidth="60px"
        height="36px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Flex align="center" justify="center" mt={1} height="100%">
          <Box
            bg="gray.500"
            borderRadius="full"
            height="7px"
            width="7px"
            mx={1}
            display="inline-block"
            sx={animationStyles.dot0}
          />
          <Box
            bg="gray.500"
            borderRadius="full"
            height="7px"
            width="7px"
            mx={1}
            display="inline-block"
            sx={animationStyles.dot1}
          />
          <Box
            bg="gray.500"
            borderRadius="full"
            height="7px"
            width="7px"
            mx={1}
            display="inline-block"
            sx={animationStyles.dot2}
          />
        </Flex>
      </Box>
    </Flex>
  );
};
